import { render, staticRenderFns } from "./adminLog.vue?vue&type=template&id=1a544907&scoped=true"
import script from "./adminLog.vue?vue&type=script&lang=js"
export * from "./adminLog.vue?vue&type=script&lang=js"
import style0 from "./adminLog.vue?vue&type=style&index=0&id=1a544907&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a544907",
  null
  
)

export default component.exports